"use client";
import { FC, MouseEventHandler, ReactNode } from "react";
import Conditional from "../Conditional/Conditional";
import { doesExist } from "@repo/shared-utils/common-utils";

interface LinkProps {
  key?: number | string;
  href?: string;
  children: ReactNode;
  className?: string;
  openInNewTab?: boolean | string;
  ctProps?: string;
  dlProps?: string;
  onClick?: MouseEventHandler<HTMLElement>;
  "aria-label"?: string;
}

const BFLLink: FC<LinkProps> = ({
  href = "",
  children,
  className,
  openInNewTab = false,
  ctProps,
  dlProps,
  onClick,
  "aria-label": ariaLabel,
}) => {
  const shouldOpenInNewTab = openInNewTab === "true" || openInNewTab === true;

  return (
    <>
      <Conditional if={doesExist(href)}>
        <a
          href={href}
          className={className}
          onClick={onClick}
          {...(shouldOpenInNewTab && {
            target: "_blank",
            rel: "noreferrer noopener",
          })}
          {...(ctProps && { "data-ct": ctProps })}
          {...(dlProps && { "data-dl": dlProps })}
          {...(ariaLabel && { "aria-label": ariaLabel })}
        >
          {children}
        </a>
      </Conditional>
      <Conditional if={!doesExist(href)}>
        <button
          type="button"
          className={className}
          onClick={onClick}
          {...(ariaLabel && { "aria-label": ariaLabel })}
        >
          {children}
        </button>
      </Conditional>
    </>
  );
};

export default BFLLink;
